import type { AlertCode, IndustrialProcessType, ProcessStepAlertStatic } from "shared";

export const MISSING_ASSEMBLY_STEP_ALERT_MESSAGE = "MISSING_ASSEMBLY_STEP_ALERT" as const;

export const CHILDREN_ALERTS_MESSAGE = "CHILDREN_ALERTS" as const;

export const MISSING_DIMENSIONS_ALERT_MESSAGE = "MISSING_DIMENSIONS_ALERT" as const;

export const LOW_MATERIAL_PRICE_ALERT_MESSAGE = "LOW_MATERIAL_PRICE_ALERT" as const;

export const MATERIAL_LAYOUT_NOT_FOUND_ALERT_MESSAGE = "MATERIAL_LAYOUT_NOT_FOUND_ALERT" as const;

export const LOW_VOLUME_ALERT_MESSAGE = "LOW_VOLUME_ALERT" as const;

export const HIGH_VOLUME_ALERT_MESSAGE = "HIGH_VOLUME_ALERT" as const;

export const EMPTY_SURFACE_TREATMENT_ALERT_MESSAGE = "EMPTY_SURFACE_TREATMENT_ALERT" as const;

export const ANALYSIS_2D_FAILED_ALERT_MESSAGE = "ANALYSIS_2D_FAILED_ALERT" as const;

export const ANALYSIS_3D_FAILED_ALERT_MESSAGE = "ANALYSIS_3D_FAILED_ALERT" as const;

export const ALERT_TYPE = {
  MACHINE_TIME: "MACHINE_TIME",
} as const;

export const ALERT_VALUES = {
  TOO_HIGH: "TOO_HIGH",
  TOO_LOW: "TOO_LOW",
} as const;

export type AlertMessage =
  | typeof MISSING_ASSEMBLY_STEP_ALERT_MESSAGE
  | typeof CHILDREN_ALERTS_MESSAGE
  | typeof MISSING_DIMENSIONS_ALERT_MESSAGE
  | typeof LOW_MATERIAL_PRICE_ALERT_MESSAGE
  | typeof MATERIAL_LAYOUT_NOT_FOUND_ALERT_MESSAGE
  | typeof EMPTY_SURFACE_TREATMENT_ALERT_MESSAGE
  | typeof ANALYSIS_2D_FAILED_ALERT_MESSAGE
  | typeof ANALYSIS_3D_FAILED_ALERT_MESSAGE
  | typeof LOW_VOLUME_ALERT_MESSAGE
  | typeof HIGH_VOLUME_ALERT_MESSAGE
  | `${(typeof ALERT_TYPE)[keyof typeof ALERT_TYPE]}_${(typeof ALERT_VALUES)[keyof typeof ALERT_VALUES]}`;

type BaseAlert<T extends AlertMessage | AlertCode> = {
  processStepId: string;
  industrialProcess: IndustrialProcessType | null;
  industrialProcessName: string | null;
  raiseAlert: boolean;
  severity: ProcessStepAlertStatic["severity"];
  message: T;
  messageParameters?: Record<string, string | number>;
};

type GenericAlert = BaseAlert<AlertMessage> & {
  conditions: {
    staticRule?: Record<string, number | boolean | string>;
  };
};

type StaticAlert = BaseAlert<AlertCode> & {
  code: AlertCode;
  conditions: {
    staticRule?: ProcessStepAlertStatic & {
      extended_description?: string;
    };
  };
};

type SimpleAlert = BaseAlert<AlertMessage>;

export const STATIC_ALERT_TO_SKIP: AlertCode[] = [
  "ALERT_100",
  "ALERT_101",
  "ALERT_103",
  "ALERT_104",
  "ALERT_105",
  "ALERT_106",
  "PREDICTION_101",
  "PREDICTION_107",
  "PREDICTION_103",
  "PREDICTION_104",
  "PREDICTION_105",
  "PREDICTION_106",
];
export type Alert = GenericAlert | StaticAlert | SimpleAlert;
